<div class="flex justify-center px-8">
    <div class="w-3/5">
        <h2
            class="text-center font-medium leading-relaxed text-2xl mt-8 p-4 text-blue-100 bg-gradient-to-t from-bg-evaluationfr to bg-evaluationto rounded-md cursor-default">
            {{this.kpi}}
            <br>
            ({{this.city}})
        </h2>
    </div>
</div>
<div class="my-8 flex flex-col justify-center items-center" *ngIf="this.is09">
    <div *ngIf="isLoading" class="flex justify-center items-center ">
        <div class="grid">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div *ngIf="!isLoading">
        <div class="my-8 flex flex-col justify-center items-center" *ngIf="this.is09">
            <div class="flex flex-col-2 justify-between items-center">
                <div class="mt-8 flex flex-col justify-center items-center">
                    <img [src]="safeBaseUrl" alt="" class="w-3/4 rounded-lg">
                    <div class="mt-1 font-light text-gray-600 italic">Before FUSILLI</div>
                </div>
                <div class="mt-8 flex flex-col justify-center items-center">
                    <img [src]="safeAllUrl" alt="" class="w-3/4 rounded-lg">
                    <div class="mt-1 font-light text-gray-600 italic">After FUSILLI</div>
                </div>
            </div>
            <div class="text-justify mx-24 mt-16" [innerHTML]="kpi9results"></div>
            <div class="mt-8 flex flex-col justify-center items-center">
                <img [src]="safeTableUrl" alt="" class="rounded-lg">
            </div>
            <div class="text-justify font-light text-gray-600 mx-32 mt-16" [innerHTML]="kpi9notes"></div>
        </div>
    </div>
</div>
<div *ngIf="!this.is09">
    <div class="flex justify-center">
        <h3 class="font-thin my-2 leading-relaxed text-xl text-gray-800 cursor-default"
            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Actions for this KPI:
        </h3>
    </div>
    <div class="w-3/5 p-8 mx-auto">
        <div class="shadow">
            <div class="border-b">
                <div class="border-l-2 border-transparent">
                    <ng-container *ngFor="let action of actions;">
                        <div class="shadow">
                            <div class="border-b">
                                <div class="border-l-2 border-transparent">
                                    <div class="grid grid-cols-1 text-grey-800 text-justify">
                                        <div class="flex justify-between items-center p-1 text-lg font-thin cursor-pointer rounded hover:bg-colortext hover:text-yellow-200"
                                            (click)="onClick($event.target.value)" value="{{action.Actions}}">
                                            {{action.Actions}}
                                            <div class="rounded-full border border-grey w-7 h-7 flex ml-4 items-center justify-center pointer-events-none"
                                                *ngIf="!action.expanded">
                                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24"
                                                    stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" viewbox="0 0 24 24" width="24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <polyline points="6 9 12 15 18 9">
                                                    </polyline>
                                                </svg>
                                            </div>
                                            <div class="rounded-full border border-grey w-7 h-7 flex ml-4 items-center justify-center pointer-events-none"
                                                *ngIf="action.expanded">
                                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24"
                                                    stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" viewbox="0 0 24 24" width="24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <polyline points="18 15 12 9 6 15">
                                                    </polyline>
                                                </svg>
                                            </div>
                                        </div>
                                        <div *ngIf="action.expanded">
                                            <div class="grid grid-cols-2">
                                                <div *ngFor="let data of barChartData">
                                                    <div *ngIf="!this.is43 && !this.is44" class="place-self-center">
                                                        <canvas baseChart width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels" [options]="barChartOptions"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                        <div *ngIf="this.is30" class="text-sm font-light text-gray-600"
                                                            [innerHTML]="kpi30notes"></div>
                                                    </div>
                                                    <div *ngIf="this.is43">
                                                        <canvas baseChart width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels" [options]="barChartOption43"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                    </div>
                                                    <div *ngIf="this.is44">
                                                        <canvas baseChart width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels" [options]="barChartOption44"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                    </div>
                                                </div>
                                                <div *ngIf="this.allowed">
                                                    <div class="text-center">
                                                        <h2 class="my-2">Click below to complete the corresponding
                                                            questionnaire:</h2>
                                                    </div>
                                                    <div class="flex flex-col place-self-center">
                                                        <button
                                                            class="border-blue-400 font-light rounded p-4 m-2 px-4 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onBaseline()">
                                                            <div class="text-lg">Baseline</div>
                                                        </button>
                                                        <button
                                                            class="border-blue-400 font-light rounded p-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onM24()">
                                                            <div class="text-xl">M24</div>
                                                        </button>
                                                        <button
                                                            class="border-blue-400 font-light rounded  p-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onM36()">
                                                            <div class="text-xl">M36</div>
                                                        </button>
                                                        <button
                                                            class="border-blue-400 font-light rounded p-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onM42()">
                                                            <div class="text-xl">M42</div>
                                                        </button>
                                                        <button (click)="onInfo()"
                                                            class="border-blue-400 font-light rounded p-4 px-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center">
                                                            <i class="fas fa-info text-3xl"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="kpi-list w-1/5" style="transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out; position: fixed; top: 25%; bottom: 0; overflow-y: auto; z-index: 5000;">
        <div class="bg-white shadow">
            <div class="border-b">
                <div class="border-l border-transparent">
                    <ng-container *ngFor="let data of data; index as i;">
                        <div class="grid grid-cols-1 text-justify">
                            <div class="flex justify-center text-md py-2 px-1 font-light rounded-md cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400"
                                (click)="onClickAgain($event.target.value)" value="{{data.Kpi_Cat}}">
                                {{data.Kpi_Cat}} &nbsp;
                                <i *ngIf="!data.expanded" class="fas fa-chevron-down text-md pointer-events-none"></i>
                                <i *ngIf="data.expanded" class="fas fa-chevron-up text-md pointer-events-none"></i>
                            </div>
                            <div *ngIf="data.expanded">
                                <div *ngFor="let kpi of kpis[i]">
                                    <div class="shadow">
                                        <div class="border-b">
                                            <div class="border-l-2 border-transparent">
                                                <div class="p-1 text-md font-thin hover:bg-evaluationto hover:text-blue-100 rounded cursor-pointer"
                                                    (click)="onKpiClickAgain($event.target.value)" value="{{kpi.Kpi}}">
                                                    {{kpi.Kpi}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>